import { useHeaders } from "hooks/api/useHeaders";
import { useQuery } from "react-query";
import { getHistoricalVersions } from "api/creatives";
import { buildMaterials } from "api/factories/creatives.factory";

export const useVersions = (materialSpecId?: number) => {
    const headers = useHeaders();

    return useQuery("versions", async () => buildMaterials(await getHistoricalVersions(headers, materialSpecId)));
};
